const url = '/aitports';
const Provider = 'Airports';
const dbModel = 'Airports';

export { url, Provider, dbModel };
